export const findMaxByKeys = (data, keys) => {
  const maxInKeys = (item) => Math.max(...keys.map((key) => item[key] || 0));

  return Math.max(...data.map(maxInKeys));
};
